import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { Check, Star } from "lucide-react";

export default function AttendanceButtons({ slug }) {
  const { t } = useLang();
  const { user } = useAuth();
  const [my, setMy] = useState(null);
  const [counts, setCounts] = useState({ going: 0, interested: 0 });

  const load = async () => {
    try {
      const { data } = await api.get(`/events/${slug}/attendance`);
      setMy(data.my_status);
      setCounts({ going: data.going, interested: data.interested });
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [slug, user]);

  const set = async (status) => {
    if (!user) { toast.error(t("attend_login_required")); return; }
    const next = my === status ? "none" : status;
    try {
      const { data } = await api.post(`/events/${slug}/attendance`, { status: next });
      setMy(data.status === "none" ? null : data.status);
      setCounts({ going: data.going, interested: data.interested });
    } catch { toast.error(t("aw_error")); }
  };

  const base = "inline-flex items-center gap-2 px-5 py-2.5 rounded-md font-medium text-sm border transition-all";
  return (
    <div className="flex flex-wrap gap-3" data-testid="attendance-buttons">
      <button
        data-testid="attend-going-btn"
        onClick={() => set("going")}
        className={`${base} ${my === "going" ? "bg-emerald-600 text-stone-950 border-emerald-400" : "bg-[#181A20] text-stone-200 border-[#272A34] hover:border-emerald-500/50"}`}
      >
        <Check className="w-4 h-4" /> {t("attend_going")}
        <span data-testid="attend-going-count" className="font-mono text-xs opacity-80">{counts.going}</span>
      </button>
      <button
        data-testid="attend-interested-btn"
        onClick={() => set("interested")}
        className={`${base} ${my === "interested" ? "bg-amber-600 text-stone-950 border-amber-400" : "bg-[#181A20] text-stone-200 border-[#272A34] hover:border-amber-500/50"}`}
      >
        <Star className="w-4 h-4" /> {t("attend_interested")}
        <span data-testid="attend-interested-count" className="font-mono text-xs opacity-80">{counts.interested}</span>
      </button>
    </div>
  );
}
